<template>
  <div class="data-table-list-member">
    <el-dropdown trigger="click" placement="bottom-start" :hide-on-click="false" @visible-change="dropdown = id" @click.native="initIsShow">
      <el-tooltip content="タグを追加" placement="top">
        <div class="pointer flex-row" style="margin-left:10px;" v-if="list.tag.length > 0">
          <div class="customize-tag-wrap" v-html="getTag(tag_list, list.tag, tag_select)">
          </div>
        </div>
        <div class="data-table-list-status-button pointer" v-else>
          <div class="list-member-user">
            <font-awesome-icon icon="tag" />
            <font-awesome-icon icon="plus-circle" class="list-member-plus" />
          </div>
        </div>
      </el-tooltip>
      <el-dropdown-menu slot="dropdown" v-if="isShow">
        <div v-if="dropdown == id">
          <el-dropdown-item
            style="font-size:12px;"
            v-for="(tag, tag_index) in tag_list"
            :key="tag.id"
            class="tag"
            @click.native="list.tag.find(lt => lt.mylist_tag_id === tag.id) ? '' : addTag(tag.id, id, index)"
            :class="list.tag.find(lt => lt.mylist_tag_id === tag.id) ? 'assign' : ''"
          >
            <div>{{ tag.tag_name }}</div>
            <div v-if="(tag_index = list.tag.findIndex(lt => lt.mylist_tag_id === tag.id)) !== -1">
              <div class="pointer times-circle" @click="removeTag(tag.id, tag_index, id, index)">
                <font-awesome-icon icon="times-circle" />
              </div>
            </div>
          </el-dropdown-item>
          <el-dropdown-item @click.native="openEditTagDrawer">
            <i class="el-icon-plus"></i>
            タグを追加する
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "memberDropdown",
  props: ["id", "list", "index", "tag_list"],
  data() {
    return {
      dropdown: "",
      isShow: true,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    tag_select() {
      return this.$store.state.tag_select;
    },
  },
  methods: {
    initIsShow() {
      this.isShow = true
    },
    addTag(tag_id, list_id, list_index) {
      this.$emit("addTag", tag_id, list_id, list_index);
    },
    removeTag(tag_id, tag_index, list_id, list_index) {
      this.$emit("removeTag", tag_id, tag_index, list_id, list_index);
    },
    getTag(tagList, mylistTag, selectedTag) {
      let html = `<div class="customize-tag" style="font-size: 10px;padding:3px 8px;">`
      if (selectedTag.id === 'all') {
        // ソート未選択
        selectedTag = tagList.find(tl => tl.id === mylistTag[0].mylist_tag_id)
        html += `<span style="overflow: hidden;max-width: 70px; text-overflow: ellipsis;">`
        html += selectedTag.tag_name
        html += `</span>`
      } else if (mylistTag !== undefined && mylistTag.length > 0) {
        // ソート選択中
        selectedTag = mylistTag.find(mt => mt.mylist_tag_id === selectedTag.id)
        if (selectedTag !== undefined) {
          selectedTag = tagList.find(tl => tl.id === selectedTag.mylist_tag_id)
        } else {
          selectedTag = tagList.find(tl => tl.id === mylistTag[0].mylist_tag_id)
        }
        html += `<span style="overflow: hidden;max-width: 70px; text-overflow: ellipsis;">`
        html += selectedTag.tag_name
        html += `</span>`
      }

      if(mylistTag.length > 1) {
        html += `</div>`
        html += `<div class="customize-tag" style="font-size: 10px;padding:3px 8px;">&plus;`
        html += mylistTag.length - 1
      }

      return html += `</div>`
    },
    openEditTagDrawer() {
      this.isShow = false
      this.$emit("openEditTagDrawer");
    },
  },
};
</script>

<style></style>
